// @flow
import {
    Correction,
    jsToCorrectionRecord,
    jsToPostRecord,
    Post
} from "./post.record";
import Record from "../flow/Record";
import { UserSettings } from "./userSettings.record";

export class Notification extends Record({
    id: "",
    userId: "",
    type: "",
    postId: "",
    post: null,
    correctionId: "",
    correction: null,
    creationDate: new Date(),
    actingUser: new UserSettings(),
    viewedAtDate: null,
    openedAtDate: null
}) {
    id: string;
    userId: string;
    type: string;
    postId: string;
    post: ?Post;
    correctionId: string;
    correction: ?Correction;
    creationDate: Date;
    actingUser: ?UserSettings;
    viewedAtDate: ?Date;
    openedAtDate: ?Date;
}

export function jsToNotificationRecord(notification: any): Notification {
    return new Notification({
        ...notification,
        post: notification.post ? jsToPostRecord(notification.post) : null,
        correction: notification.correction
            ? jsToCorrectionRecord(notification.correction)
            : null,
        creationDate: new Date(notification.creationDate),
        viewedAtDate: notification.viewedAtDate
            ? new Date(notification.viewedAtDate)
            : null,
        openedAtDate: notification.openedAtDate
            ? new Date(notification.openedAtDate)
            : null
    });
}



// WEBPACK FOOTER //
// ./src/records/notification.record.js